import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from '@/views/Login'
import Http404 from '@/views/Http404'
import Templates from '@/views/Templates'
import Watch from '@/views/Watch'

import store from '../store'

import companies from './companies'
import users from './users'
import cars from './cars'
import trackDevices from './track-devices'
import drivers from './drivers'
import serves from './serves'
import rents from './rents'

Vue.use(VueRouter)

const routes = [
  {
    path: '/site/login',
    component: Login,
    meta: {
      title: 'Вход'
    }
  }, {
    path: '/',
    redirect: '/watch'
  },
  ...companies, // companies routes
  ...users, // users routes
  ...trackDevices, // tracking devices routes
  ...cars, // cars and car documents routes
  ...drivers, // drivers and driver documents routes
  ...serves, // service and service works routes
  ...rents, // rents routes
  {
    path: '/watch',
    component: Watch,
    meta: {
      title: 'Наблюдение',
      layout: 'BaseWorkspaceLayout'
    }
  }, {
    path: '/templates',
    component: Templates,
    meta: {
      title: 'Шаблоны',
      layout: 'BaseWorkspaceLayout'
    }
  }, {
    path: '*',
    component: Http404,
    meta: {
      title: 'Страниза не найдена'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  store.dispatch('taxi/users/loadAuthedUser').then(user => {
    if (!user && to.path !== '/site/login') {
      return next('site/login')
    }
    if (to.path === '/users/create' && !user.roles['Администратор']) {
      return next('/users')
    }
    return next()
  })
})
router.afterEach(to => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
})

export default router
